/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useQuery } from '@tanstack/react-query';

// Lib
import { apiClient } from '@lib/api-client';

// Constants
import { queryKeys } from '@config/constants/query-keys';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */
export type TApiResponseStatus = {
	name: string;
	version: string;
	build: string;
};

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getStatus =
	(): Promise<TApiResponseStatus> => {
		return apiClient.get('/status');
	};

/* -------------------------------------------------------------------------- */
/*                                     Hook                                   */
/* -------------------------------------------------------------------------- */
export const useStatus = () => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: [queryKeys.status.key],
		queryFn: () => getStatus(),
		staleTime: Infinity,
	});

	return {
		version: data && data.version ? data.version : '',
		build: data && data.build ? data.build : '',
		isLoading: isFetching && !isFetched,
		isFetched,
	};
};
